<template>
  <div class="column_center_around order_method_container dine-in-container" :class="{ 'no-table': !storeHasDineInTables }">
    <div class="row_center_center" v-if="storeHasDineInTables">
      <text class="title">桌號</text>
      <text class="title" style="color: #c0462e;">必選</text>
    </div>  
    <div v-if="storeHasDineInTables" class="table_select" :class="tableName ? 'row_center_center' : 'row_center_between'" @click="showTableOption = true">
      <text class="text-center font-normal" :class="tableName ? 'text-black' : 'text-[rgba(0,0,0,0.3)]'">{{ tableName || '請選擇桌號 *' }}</text>
      <text id="expand_more" class="button-icon" style="color: #FBCB02; font-size: 28px; width: 28px; height: 28px;"
        v-if="!tableName">expand_more</text>
    </div>
    
    <!-- 發票資訊分隔線 -->
    <div v-if="storeHasDineInTables && shouldShowInvoiceSelector" class="invoice-divider"></div>
    
    <!-- 整合 InvoiceSelector 組件 -->
    <InvoiceSelector 
      ref="invoiceSelectorRef"
      v-if="shouldShowInvoiceSelector"
      @invoice-updated="handleInvoiceUpdated"
      @validation-error="handleValidationError"
    />
    
    <button class="button" :disabled="isSubmitting" @click="toOrderPage">
      {{ isSubmitting ? '處理中…' : '內用點餐' }}
    </button>
    <SelectDineInTable :tableOptions="dineInTables" v-if="showTableOption" @close="showTableOption = false" @setTable="setTableData" />
  </div>
</template>
<script>
import commonUtilities from "@/utils/common.utils";
import selectDineInTable from "./selectDineInTable.vue";
import InvoiceSelector from "./InvoiceSelector.vue";

export default {
  components: {
    SelectDineInTable: selectDineInTable,
    InvoiceSelector,
  },
  data() {
    return {
      tableData: {},
      showTableOption: false,
      // 送出中旗標：防止驗證期間重複點擊
      isSubmitting: false
    };
  },
  computed: {
    getCurrentStore() {
      return this.$store.state.basic.currentStore;
    },
    dineInTables() {
      return this.$store.getters['spreadsheet/dineInTables']
    },
    tableName() {
      return this.$store.getters['cart/tableName']
    },
    areaId() {
      return this.$store.getters['cart/tableAreaId']
    },
    tableIndex() {
      return this.$store.getters['cart/tableIndex']
    },
    storeHasDineInTables() {
      return this.dineInTables.length >= 1
    },
    // 判斷是否顯示發票選項
    shouldShowInvoiceSelector() {
      return this.$store.getters['basic/enableInvoiceSelector']
    }
  },
  methods: {
    async toOrderPage() {
      // 送出中不重複觸發（避免驗證期間連點）
      if (this.isSubmitting) return
      this.isSubmitting = true
      try {
        // 觸發所有輸入框失焦，確保發票資料已更新
        if (document.activeElement instanceof HTMLElement) {
          document.activeElement.blur()
        }

        if (this.storeHasDineInTables && (!this.areaId || !this.tableName)) {
          commonUtilities.createToast('warning', '請選擇桌號')
          return
        }
        if (!this.storeHasDineInTables) {
          this.$store.commit('cart/setTableData', {
            areaId: null,
            tableIndex: -1,
          })
        }

        // 驗證發票資訊（放在本地必填檢查之後，避免白等 API）
        if (this.shouldShowInvoiceSelector && this.$refs.invoiceSelectorRef) {
          const isValid = await this.$refs.invoiceSelectorRef.validate()
          if (!isValid) {
            const errorMessage = this.$refs.invoiceSelectorRef.errorMessage
            if (errorMessage) {
              commonUtilities.createToast('error', errorMessage)
            }
            return
          }
        }

        // payment 物件已經包含最新的發票資料（由 InvoiceSelector 即時更新）
        // 不需要額外處理，直接使用即可

        const data = {
          method: 'dineIn'
        }
        this.$emit('toOrderPage', data)
      } finally {
        this.isSubmitting = false
      }
    },
    
    // 處理發票資料更新事件
    handleInvoiceUpdated(invoiceData) {
      console.log('dineIn.vue 收到發票資料更新:', invoiceData)
      // InvoiceSelector 已經更新了 Vuex store，這裡只需要記錄日誌
    },
    
    // 處理發票驗證錯誤事件
    handleValidationError(errorMessage) {
      console.error('dineIn.vue 收到發票驗證錯誤:', errorMessage)
      // 可以選擇顯示錯誤訊息給使用者
      // commonUtilities.createToast('error', errorMessage)
    }
  },
};
</script>
<style lang="scss" scoped>
.table_select {
  width: 100%;
  height: 54px;
  padding: 0 4%;
  border: #AAAAAA 1px solid;
  border-radius: 6px;
  color: #000;
  font-size: 22px;
  font-weight: 500;
  font-family: PingFang SC;
  margin: 18px 0 15px;
}

.invoice-divider {
  width: 100%;
  height: 1px;
  background-color: #DDDDDD;
  margin: 16px 0;
}

.dine-in-container {
  gap: 16px;
}

.dine-in-container.no-table {
  min-height: 13rem;
  justify-content: flex-start;
}

.dine-in-container .button {
  margin-top: 4px;
}
</style>
